import * as React from "react";
import {connect} from "react-redux";
import {RootState} from "../../../../store/reducer/root/RootState";
import User from "../../../../model/user/User";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import SearchDropDown from "../../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import TextDropDownWrapper from "../../../../hiberUiKit/src/molecules/TextDropDownWrapper/TextDropDownWrapper";
import {Option} from "ts-option";

interface IComponentProps {
	/**
	 * Selected business development partner id.
	 */
	businessDevelopmentPartnerId: Option<string>;
	/**
	 * On change bdp callback.
	 * @param {User} user
	 */
	onChange?: (user: User) => void;
	/**
	 * Indicate if selection is removable (shows "x" button).
	 */
	removable?: boolean;
	/**
	 * On delete icon click callback.
	 * @param {React.MouseEvent<HTMLSpanElement>} evt
	 */
	onRemoveClick: (evt: React.MouseEvent<HTMLSpanElement>) => void;
}

interface IReduxProps {
	/**
	 * All not disabled users with "business development partner" role.
	 */
	businessDevelopmentPartners: User[]
}

interface IState {
	dropDownVisible: boolean;
}

type Props = IComponentProps & IReduxProps;

class BDPSelector extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {dropDownVisible: false};
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onSelect = this.onSelect.bind(this);
	}

	render() {
		let businessDevelopmentPartners: User[] = this.props.businessDevelopmentPartners.filter(bdp => !bdp.disabled);
		const selectedBDP: User = this.props.businessDevelopmentPartnerId.map(
			bdpId => {
				businessDevelopmentPartners = businessDevelopmentPartners.filter(a => a.id != bdpId);
				return this.props.businessDevelopmentPartners.filter(a => a.id == bdpId)[0]
			}
		).orNull;
		const agentTxt = `BDP: ${selectedBDP ? selectedBDP.getDisplayName(true) : "Unassigned"}`;
		return (
			<TextDropDownWrapper text={agentTxt}
								 onClick={this.toggleDropdown}
								 onRemoveClick={this.props.onRemoveClick}
								 removable={this.props.removable}>
				{this.state.dropDownVisible &&
				<DropDownWrapper onOutsideClick={() => {this.setState({dropDownVisible: false})}}>
					<SearchDropDown items={businessDevelopmentPartners}
									onChange={this.onSelect}
									itemToLabel={(user: User) => user.getDisplayName()}
									itemToId={(user: User) => user.id}
									searchInputIcon={Icon.User}/>
				</DropDownWrapper>
				}
			</TextDropDownWrapper>
		);
	}

	toggleDropdown() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	onSelect(user: User) {
		this.toggleDropdown();
		this.props.onChange(user);
	}
}

function mapStateToProps(state: RootState) {
	return {
		businessDevelopmentPartners: state.user.users.getOrElse([]).filter(u => u.isBusinessDevelopmentPartner())
	}
}

export default connect<IReduxProps, null, IComponentProps>(mapStateToProps, null)(BDPSelector)
